import { navigate, RouteUpdateArgs } from "gatsby";

export const onRouteUpdate = ({ location }: RouteUpdateArgs): void => {
  if (location.pathname === "/standorte/") {
    navigate("/");
  }
};
